export default __webpack_public_path__ + "static/shopeedatascience2019-194f90c46b0940e30342282e93576b6b.jpeg";